module.exports = __webpack_public_path__ + "static/FrolicLogo-200-e7b73f82b608c7a505e991a69d5ed627.png";